import { ALL_PERMISSIONS, type PermissionId, type PermissionName } from "./catalog";

const PERMISSION_ID_BY_NAME = Object.fromEntries(
  ALL_PERMISSIONS.map((permission) => [permission.name, permission.id]),
) as Record<PermissionName, PermissionId>;

export function getPermissionId(name: PermissionName): PermissionId {
  return PERMISSION_ID_BY_NAME[name];
}

export function getPermissionById(
  id: number,
): (typeof ALL_PERMISSIONS)[number] | undefined {
  return ALL_PERMISSIONS.find((permission) => permission.id === id);
}
